module.exports = __webpack_public_path__ + "img/Add Patient - Green - Selected.a1244f59.png";